import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CopyToClipboard from 'react-copy-to-clipboard';
import TextArea from 'antd/lib/input/TextArea';
import { Flex, NotificationButton } from 'ui';
import { UploadButton } from '../../../header/upload-xml/components/upload-xml-button';

const StyledTextArea = styled(TextArea)`
  resize: none;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const Text = styled.p`
  white-space: pre-wrap;
  margin-top: 10px;
  font-size: 14px;
`;

const Reference = styled.p`
  margin-top: 10px;
  font-size: 12px;
`;

const Buttons = styled(Flex)`
  float: right;
  margin-top: 10px;
  > :first-child {
    margin-right: ${p => p.multiple ? '5px' : '0px'};
  }
`;

const GenericError = ({ sections, actions, reference, close, intl, history }) => {
  const renderSection = ({ type, text, subText }) => {
    if (type === 'copy') {
      return (
        <Section>
          <Text>{text}</Text>
          <StyledTextArea rows={4} disabled={true} value={subText.join('\n')} />
          <CopyToClipboard text={subText.join('\n')}>
            <UploadButton
              marginTop={10}
            >
              {intl.formatMessage({ id: 'fileUpload.COPY_TO_CLIPBOARD' })}
            </UploadButton>
          </CopyToClipboard>
        </Section>
      );
    }
    return (
      <Section>
        <Text>
          {text}
        </Text>
      </Section>
    );
  };

  const renderAction = ({ id, text, url }, isPrimary) => {
    const handleClick = () => {
      if (id === 'cancel') {
        close();
      } else if (id === 'user-redirect') {
        close();
        history.push(`/${url}`);
      } else {
        close();
      }
    };
    return (
      <NotificationButton
        primary={isPrimary}
        onClick={handleClick}
      >
        {text}
      </NotificationButton>
    );
  };

  const renderActions = () => {
    if (!actions?.length) {
      return null;
    }
    return (
      <Buttons multiple={actions?.length > 1}>
        {actions?.sort((a, b) => a.sort - b.sort)?.map(renderAction)}
      </Buttons>
    );
  };

  return (
    <>
      {sections?.sort((a, b) => b.sort - a.sort)?.map(s => renderSection(s))}
      {reference ? <Reference>{reference}</Reference> : null}
      {renderActions(actions)}
    </>
  );
};

GenericError.propTypes = {
  sections: PropTypes.array,
  actions: PropTypes.array,
  reference: PropTypes.string,
  close: PropTypes.func,
  intl: PropTypes.object,
  history: PropTypes.object,
};

export default GenericError;
